import React from 'react';
import PropTypes from 'prop-types';
import { MemoryPhotoV1 } from '../MemoryPhotoV1';
import { MemoryAnswersV1 } from '../MemoryAnswersV1';
import { useAutoSubmitAnswer } from '../../shared/use-auto-submit-answer';
import styles from './QuestionAnswerSlideV8.css';

function QuestionAnswerSlideV8({ id, question, hint, imageId, answers, submitAnswer, submitTemporaryAnswer, userResponse = {}, delay }) {
    const { selectAnswer } = useAutoSubmitAnswer({ id, question, userResponse, submitAnswer, submitTemporaryAnswer, delay });

    return (
        <div className={styles.form} key={id}>
            {Boolean(imageId) && <MemoryPhotoV1 imageId={imageId} />}
            <div className={styles.text}>
                <h1 className={styles.question}>{question}</h1>
                {Boolean(hint) && <p className={styles.hint}>{hint}</p>}
            </div>
            <MemoryAnswersV1
                answers={answers}
                selectedId={userResponse?.id}
                onSelect={selectAnswer}
            />
        </div>
    );
}

QuestionAnswerSlideV8.propTypes = {
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    hint: PropTypes.string,
    imageId: PropTypes.string,
    answers: PropTypes.array.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    delay: PropTypes.number
};

export {
    QuestionAnswerSlideV8
};
